import React from "react";
import { Box, DialogContent, DialogTitle } from "@mui/material";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";
import GridItem from "../Grid/GridItem";
import PayProviderFilter from "../Filters/PayProviderFilter";
import ApiProviderFilter from "../Filters/ApiProviderFilter";
import VestigingFilter from "./VestigingFilter";
import { connect } from "react-redux";
import GridContainer from "../Grid/GridContainer";
import SalesareaTypeFilter from "../Filters/SalesareaTypeFilter";
import AppTargetFilter from "../Filters/AppTargetFilter";

function AdvancedFilter(props) {
  return (
    <>
      <DialogTitle>Advanced Filter</DialogTitle>
      <DialogContent style={{ width: "100vw", maxWidth: "100%" }}>
        <GridContainer>
          <AuthenticationWrapper permissionKey={"vestigingen.filter_on_pay_provider"}>
            <GridItem md={12} xs={12}>
              <Box style={{ marginTop: 16 }}>
                <PayProviderFilter />
              </Box>
            </GridItem>
          </AuthenticationWrapper>
          <AuthenticationWrapper permissionKey={"vestigingen.filter_on_api_provider"}>
            <GridItem md={12} xs={12}>
              <Box style={{ marginTop: 16 }}>
                <ApiProviderFilter />
              </Box>
            </GridItem>
          </AuthenticationWrapper>
          <GridItem md={12} xs={12}>
            <Box style={{ marginTop: 16 }}>
              <SalesareaTypeFilter />
            </Box>
          </GridItem>
          <GridItem md={12} xs={12}>
            <Box style={{ marginTop: 16 }}>
              <AppTargetFilter />
            </Box>
          </GridItem>
        </GridContainer>
        <Box style={{ marginTop: 16 }}>
          <VestigingFilter
            extraFilters={{
              payProvider: props.payProvider,
              apiProvider: props.apiProvider,
              salesarea_type: props.salesarea_type,
              appTarget: props.appTarget,
            }}
            showAdvancedButton={false}
            useMenukaartReferences={true}
          />
        </Box>
      </DialogContent>
    </>
  );
}

const mapStateToProps = (state) => ({
  ["payProvider"]: state.filtersV2["payProvider"],
  ["apiProvider"]: state.filtersV2["apiProvider"],
  ["salesarea_type"]: state.filtersV2["salesarea_type"],
  ["appTarget"]: state.filtersV2["appTarget"],
  /*   ["vestiging_id"]: state.filtersV2["vestiging_id"], */
});

export default connect(mapStateToProps)(AdvancedFilter);
